
var originalEnsureChunk = __webpack_require__.e;
var retryDelays = [1000,2000,4000];
__webpack_require__.e = function () {
  var args = arguments;
  function attempt(index) {
    return originalEnsureChunk.apply(null, args).catch(function (error) {
      if (index >= retryDelays.length) {
        throw error;
      }
      return new Promise(function (resolve) {
        setTimeout(resolve, retryDelays[index]);
      }).then(function () {
        return attempt(index + 1);
      });
    });
  }
  return attempt(0);
};
